import React, { createContext, useState } from 'react';
import { calculateResults } from '../utils/calculations';
import { db } from '../firebase';
import { collection, addDoc, serverTimestamp, setDoc } from 'firebase/firestore';

export const CalculatorContext = createContext();

export const CalculatorProvider = ({ children }) => {
  // Initial inputs with sensible defaults
  const [inputs, setInputs] = useState({
    city: '',
    averageSolarIrradiance: 900,  // W/m²
    coolingDaysPerYear: 200,
    hoursPerDay: 8,
    roofArea: 100,                // m²
    existingAlbedo: 0.2,
    roofType: 'Concrete',
    insulated: false,
    rValue: 0,
    roofSlope: 'Flat',
    roofAge: 5,
    coolingCapacity: 10,          // TR
    cop: 3.0,
    costPerKWh: 7.5,              // local currency
    coolAlbedo: 0.85,
    thermalEmittance: 0.9,
    sri: 130,
    materialCostPerM2: 200,
    laborCostPerM2: 50,
    emissionFactor: 0.82,         // kg CO₂/kWh
    serviceLife: 10,              // years
    annualDegradation: 0.5        // %
  });

  const [results, setResults] = useState(null);

  const updateInput = (field, value) => {
    setInputs(prev => ({ ...prev, [field]: value }));
  };

  const computeResults = async (user) => {
    const computed = calculateResults(inputs);
    setResults(computed);

    if (user) {
      try {
        const sessionsCol = collection(db, 'users', user.uid, 'sessions');
        const docRef = await addDoc(sessionsCol, {
          inputs,
          results: computed,
          createdAt: serverTimestamp(),
        });
        await setDoc(docRef, { sessionId: docRef.id }, { merge: true });
      } catch (err) {
        console.error('Error saving session data', err);
      }
    }
  };

  return (
    <CalculatorContext.Provider value={{ inputs, updateInput, results, computeResults }}>
      {children}
    </CalculatorContext.Provider>
  );
};
